export default "__VITE_ASSET__217b8e55__"